import React, { createContext, useReducer, useMemo } from 'react';
import { getAsianMarketTypes } from '../../../helpers/asianHelpers';
export const MarketContext = createContext([]);

function reducer (state, action) {
    const { payload = {} } = action;
    switch (action.type) {
        case 'CHANGE': {
            const temp = state.map(item => item);
            temp.splice(payload.index, 1, payload.value);
            return temp;
        }
        default:
            throw new Error();
    }
}

// eslint-disable-next-line react/prop-types
export function MarketContextProvider ({ sportAlias, gameType, children }) {
    const market = useMemo(() => getAsianMarketTypes(gameType, sportAlias), [sportAlias, gameType]);
    const [state, dispatch] = useReducer(reducer, market.map(() => 0));
    return <MarketContext.Provider value={[state, dispatch]} > {children} </MarketContext.Provider>;
}
